<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { computed } from 'vue'
import { useContentHelper } from '~/composables/useContentHelper'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import LinkOrAnchor from '~/components/utils/LinkOrAnchor.vue'

const props = defineProps<{ resource: BaseItem; isAnchor?: boolean }>()

const { getTitle } = useContentHelper()
const { buildResourceUrl } = useUrlBuilder()

const title = computed(() => getTitle(props.resource))
const link = computed(() => buildResourceUrl(props.resource))
</script>
<template>
  <LinkOrAnchor
    :link="link"
    class="flex h-full w-full items-center border border-subject-borderblue bg-subject-lightblue p-6 text-xl font-bold text-subject-darkblue ring-inset transition duration-100 hover:bg-white hover:ring focus-visible:ring"
    :is-anchor="props.isAnchor"
  >
    {{ title }}
  </LinkOrAnchor>
</template>
